
  export function emotionalBio (birthdate, currentdate) {
    let totalDays = currentdate-birthdate;
    let cycle =28;
    return Number( Math.sin(totalDays/cycle*2*Math.PI));
  }

  export function intellectualBio (birthdate, currentdate){
    let totalDays = currentdate-birthdate;
    let cycle =33;
    return Number( Math.sin(totalDays/cycle*2*Math.PI));
  }
  
  export function instictualBio (birthdate, currentdate){
    let totalDays = currentdate-birthdate;
    let cycle =38;
    return Number( Math.sin(totalDays/cycle*2*Math.PI));
  }

  export function PhysicalBio (birthdate, currentdate){
    console.log(birthdate, currentdate)
    let totalDays = currentdate-birthdate;
    let cycle =23;
    return Number( Math.sin(totalDays/cycle*2*Math.PI));
  }

  export function percentage(bio){
    return Math.round(bio*100)+"%";
  }

  export function getMoonPhase(birthYear, birthMonth, birthDay){
    return Moon.phase(birthYear, birthMonth+1, birthDay);
  }

 const Moon = {
    phases: ['new-moon', 'waxing-crescent-moon', 'quarter-moon', 'waxing-gibbous-moon', 'full-moon', 'waning-gibbous-moon', 'last-quarter-moon', 'waning-crescent-moon'],
    phase: function (year, month, day) {
      let c  = 0;
      let e = 0;
      let jd =0;
      let b = 0;
  
      if (month < 3) {
        year--;
        month += 12;
      }
  
      ++month;
      c = 365.25 * year;
      e = 30.6 * month;
      jd = c + e + day - 694039.09; // jd is total days elapsed
      jd /= 29.5305882; // divide by the moon cycle
      b = parseInt(jd); // int(jd) -> b, take integer part of jd
      jd -= b; // subtract integer part to leave fractional part of original jd
      b = Math.round(jd * 8); // scale fraction from 0-8 and round
  
      if (b >= 8) b = 0; // 0 and 8 are the same so turn 8 into 0
      return {phase: b, name: Moon.phases[b]};
    }
  };

  const getAverage= (phy, emo, inte, inst) =>{
    return (phy+emo+inte+inst)/4.0;
  }
  

export function calculateBiorhythmResults(startDate, targetDate) {
  const physical = PhysicalBio(startDate, targetDate);
  const emotional = emotionalBio(startDate, targetDate);
  const intellectual = intellectualBio(startDate, targetDate);
  const instinctual = instictualBio(startDate, targetDate);

  const average = getAverage(physical, emotional, intellectual, instinctual);

  const birthMoon = getMoonPhase(
    startDate.getFullYear(),
    startDate.getMonth() ,
    startDate.getDate()
  );

  const targetMoon = getMoonPhase(
    targetDate.getFullYear(),
    targetDate.getMonth(),
    targetDate.getDate()
  );


  return {
    physical,
    emotional,
    intellectual,
    instinctual,
    average,
    birthMoon,
    targetMoon
  };
}